import { getKeyBySelector } from '../keys';
/**
 * Converts an array to an object. For example:
 * ```
 * const example = [
 *     { id: 1, type: 1 },
 *     { id: 2, type: 1 },
 *     { id: 3, type: 2 }
 * ];
 * const exampleObjects = convertArrayToObject(example, 'id', x => x);
 * const exampleFetchedObjects = convertArrayToObject(example, 'id', x => createFetchedData(x, 60) );
 * console.log(exampleObjects);
 * ```
 * => {
 *     1: { id: 1, type: 1 },
 *     2: { id: 2, type: 1 },
 *     3: { id: 3, type: 2 },
 * }
 * @param array The array from which the object will be created.
 * @param keySelector The key for each value in the array.
 * @param mapperFn A function that maps each value
 */
export const convertArrayToObject = (array, keySelector, mapperFn) => {
    return array.reduce((acc, item) => {
        const key = getKeyBySelector(item, keySelector);
        acc[key] = mapperFn ? mapperFn(item) : item;
        return acc;
    }, {});
};
//# sourceMappingURL=convert-array-to-object.js.map